module.exports = __webpack_public_path__ + "static/img/qrcode-slide.1940c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode-slide.png
// module id = 5ade
// module chunks = 125